import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../components/Layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Brand = makeShortcode("Brand");
const layoutProps = {
  _frontmatter
};
const MDXLayout = Layout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Tooling`}</h1>
    <p>{`For users of VSCode, `}<Brand mdxType="Brand">{`astroturf`}</Brand>{` is best used with its extension:`}</p>
    <p><a parentName="p" {...{
        "href": "https://marketplace.visualstudio.com/items?itemName=monasticpanic.vscode-astroturf"
      }}>{`https://marketplace.visualstudio.com/items?itemName=monasticpanic.vscode-astroturf`}</a></p>
    <p>{`The astroturf extension handles syntax highlighting and linting for the
style tags as well as validation and intellisense for configuration files.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      